import React, { CSSProperties } from "react";
import {Grid, Layout} from "antd";
import {
    Switch,
    Route,
} from "react-router-dom";
import { useSelector } from 'react-redux';

import * as T from 'utils/types';
import SearchPage from "./search_page";
import SettingPage from "./setting_page/SettingPage";
import PrivateRoute from '../authentication/PrivateRoute';
import Error404 from "components/errors/Error404";
import ToHomeButton from "components/ToHomeButton";
// import ProfilePage from "./profile_page/ProfilePage";
import AboutPage from "components/AboutPage";
import ProfilePg from "./profile_page/ProfilePg";
import * as H from "hooks";
import AddCreation from "./setting_page/CreationPanel/AddCreation";
import EditCreation from "./setting_page/CreationPanel/EditCreation";
import { URLS } from "../../utils-creation/constants";

const {Content} = Layout;

const MyContent = () => {

    const {
        status: fcltDept_static_status
    } = useSelector((state: T.RootState) => state.fcltDept_static);

    const screens = Grid.useBreakpoint();
    const contentStyle: CSSProperties = screens.lg
        ? { padding: '16px 6vw', minHeight: 800 }
        : screens.md
        ? { padding: 24 }
        : { padding: 12 };

    H.useScrollToTop(); 
    // this way when user switch between different components, 
    // the scroll position will always be on top

    return (
        <Content
            className="sfu-white-background"
            style={contentStyle}
        >
            <Switch>
                <PrivateRoute path={URLS.RESEARCH_CREATION_NEW}>
                    <AddCreation />
                </PrivateRoute>
                <PrivateRoute path={`${URLS.RESEARCH_CREATION_EDIT}/:id`}>
                    <EditCreation />
                </PrivateRoute>
                <PrivateRoute path='/settings/:selectedTab'>
                    <SettingPage/>
                </PrivateRoute>
                <Route exact path='/profile/:randomID'>
                    <ProfilePg/>
                </Route>
                <Route exact path='/about'>
                    <AboutPage/>
                </Route>
                <Route exact path='/'>
                    {fcltDept_static_status==="succeeded"&&<SearchPage/>}
                </Route>
                <Route path="*">
                    <Error404 extra={<ToHomeButton/>} />
                </Route>
            </Switch>
        </Content>
    )
};

export default MyContent;